{
    "xtgor": {
        "key": "xtgor",
        "position": {
            "x": 5,
            "y": 5,
            "z": 1
        },
        "tag": "tree", "imageKey": "book/mess"
    },
    "3RCv_": {
        "key": "3RCv_",
        "position": {
            "x": 6,
            "y": 6,
            "z": 1
        },
        "tag": "tree", "imageKey": "book/mess"
    },
    "RU5ez": {
        "key": "RU5ez",
        "position": {
            "x": 7,
            "y": 5,
            "z": 1
        },
        "tag": "tree", "imageKey": "book/mess"
    },
    "TdaTp": {
        "key": "TdaTp",
        "position": {
            "x": 6,
            "y": 4,
            "z": 1
        },
        "tag": "tree", "imageKey": "book/mess"
    },
    "iEfeC": {
        "position": {
            "x": 3,
            "y": 6,
            "z": 1
        },
        "key": "iEfeC",
        "tag": "spawn"
    },
    "kadct": {
        "position": {
            "x": 8,
            "y": 3,
            "z": 1
        },
        "key": "kadct",
        "tag": "spawn"
    },
    "hjDCn": {
        "position": {
            "x": 10,
            "y": 7,
            "z": 1
        },
        "key": "hjDCn",
        "tag": "spawn"
    },
    "w71_j": {
        "position": {
            "x": 2,
            "y": 3,
            "z": 1
        },
        "key": "w71_j",
        "tag": "spawn"
    },
    "b3wfT": {
        "position": {
            "x": 5,
            "y": 8,
            "z": 1
        },
        "key": "b3wfT",
        "tag": "spawn"
    },
    "EVk_G": {
        "position": {
            "x": 11,
            "y": 4,
            "z": 1
        },
        "key": "EVk_G",
        "tag": "spawn"
    },
    "vTroN": {
        "position": {
            "x": 1,
            "y": 5,
            "z": 1
        },
        "key": "vTroN",
        "tag": "spawn"
    },
    "45e55": {
        "position": {
            "x": 5,
            "y": 4,
            "z": 1
        },
        "key": "45e55",
        "tag": "spawn-monster"
    },
    "DN3sh": {
        "position": {
            "x": 8,
            "y": 8,
            "z": 1
        },
        "key": "DN3sh",
        "tag": "spawn-monster"
    },
    "C9pqx": {
        "position": {
            "x": 2,
            "y": 7,
            "z": 1
        },
        "key": "C9pqx",
        "tag": "spawn-monster"
    },
    "wcYBw": {
        "position": {
            "x": 9,
            "y": 3,
            "z": 1
        },
        "key": "wcYBw",
        "tag": "spawn-monster"
    },
    "GEFhA": {
        "position": {
            "x": 11,
            "y": 6,
            "z": 1
        },
        "key": "GEFhA",
        "tag": "spawn-monster"
    },
    "MoAZa": {
        "position": {
            "x": 3,
            "y": 3,
            "z": 1
        },
        "key": "MoAZa",
        "tag": "spawn-monster"
    },
    "s1mv1": {
        "position": {
            "x": 1,
            "y": 4,
            "z": 1
        },
        "key": "s1mv1",
        "tag": "spawn-monster"
    },
    "WJc4A": {
        "position": {
            "x": 7,
            "y": 6,
            "z": 1
        },
        "key": "WJc4A",
        "tag": "spawn-monster"
    },
    "uoib2": {
        "key": "uoib2",
        "position": {
            "x": 4,
            "y": 7,
            "z": 1
        },
        "tag": "tree", "imageKey": "book/mess"
    },
    "pYqIR": {
        "key": "pYqIR",
        "position": {
            "x": 4,
            "y": 3,
            "z": 1
        },
        "tag": "tree", "imageKey": "book/mess"
    }
}